import React from 'react';
import {IntlProvider, FormattedMessage, useIntl} from 'react-intl';

import {
  Form,
  FormGroup,
  FormField,
  Button
} from 'semantic-ui-react'

const CardAddCoPhysicianUX = (props: any) => {
    return(
      <div>
        <Form
          id="CardAddCoPhysicianUX-Form-1">
          <FormGroup
            id="CardAddCoPhysicianUX-FormGroup-2">
            <FormField
              id="CardAddCoPhysicianUX-FormField-3"
              inline={true}>
              <label
                id="CardAddCoPhysicianUX-label-4"
                style={{ fontWeight: "bold" }}>
                {props.primary_doctor}
              </label>
              <label
                id={props.languageUX === "en" ? "" : "CardAddCoPhysicianUX-label-5"}
                style={{ color: "grey" }}>
                {props.languageUX === "en" ? "The attending physician" : "แพทย์เจ้าของไข้"}
              </label>
            </FormField>
          </FormGroup>
          <hr
            id="CardAddCoPhysicianUX-hr-12">
          </hr>
          <FormGroup
            id="CardAddCoPhysicianUX-FormGroup-8">
            <FormField
              id="CardAddCoPhysicianUX-FormField-9">
              <label
                id="CardAddCoPhysicianUX-label-11"
                style={{ color: "grey" }}>
                {props.languageUX === "en" ? "Associate Physician" : "แพทย์ผู้ร่วมรักษา"}
              </label>
            </FormField>
          </FormGroup>
          <FormGroup
            id="CardAddCoPhysicianUX-FormGroup-13"
            style={{ display: "flex", alignItems: "center", marginBottom: "30px" }}>
            <FormField
              id="CardAddCoPhysicianUX-FormField-14"
              width={14}>
              <div
                id="CardAddCoPhysicianUX-div-16">
                {props.addDoctorSearchbox}
              </div>
            </FormField>
            <FormField
              id="CardAddCoPhysicianUX-FormField-15"
              width={2}>
              <Button
                color="green"
                disabled={!props.addCoPhysicianSequence?.coPhysician?.id}
                icon="plus"
                id="CardAddCoPhysicianUX-Button-17"
                onClick={props.onAddCoPhysician}
                size="mini">
              </Button>
            </FormField>
          </FormGroup>
          <FormGroup
            id="CardAddCoPhysicianUX-FormGroup-18">
            <div
              id="CardAddCoPhysicianUX-div-19"
              style={{ width: "100%" }}>
              {props.coPhysicianComponent}
            </div>
          </FormGroup>
          <FormGroup
            id="CardAddCoPhysicianUX-FormGroup-20">
            <FormField
              id="CardAddCoPhysicianUX-FormField-21"
              width={9}>
            </FormField>
            <FormField
              id="CardAddCoPhysicianUX-FormField-22"
              width={4}>
              <div
                id="CardAddCoPhysicianUX-div-26">
                {props.buttonSave}
              </div>
            </FormField>
            <FormField
              id="CardAddCoPhysicianUX-FormField-23"
              width={3}>
              <Button
                color="red"
                id={props.languageUX === "en" ? "" : "CardAddCoPhysicianUX-Button-25"}
                onClick={props.onClose}>
                {props.languageUX === "en" ? "Close" : "ปิด"}
              </Button>
            </FormField>
          </FormGroup>
        </Form>
      </div>
    )
}


export default CardAddCoPhysicianUX

export const screenPropsDefault = {"language":"EN"}

/* Date Time : Thu Sep 11 2025 08:09:07 GMT+0000 (Coordinated Universal Time)
/* Original screen Data ************************************************************

{
  "elements": [
    {
      "id": 0,
      "name": "div",
      "parent": -1,
      "seq": 0
    },
    {
      "from": "semantic-ui-react",
      "id": 1,
      "name": "Form",
      "parent": 0,
      "props": {
        "id": {
          "type": "value",
          "value": "CardAddCoPhysicianUX-Form-1"
        }
      },
      "seq": 1,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 2,
      "name": "FormGroup",
      "parent": 1,
      "props": {
        "id": {
          "type": "value",
          "value": "CardAddCoPhysicianUX-FormGroup-2"
        }
      },
      "seq": 2,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 3,
      "name": "FormField",
      "parent": 2,
      "props": {
        "id": {
          "type": "value",
          "value": "CardAddCoPhysicianUX-FormField-3"
        },
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 3,
      "void": false
    },
    {
      "from": null,
      "id": 4,
      "name": "label",
      "parent": 3,
      "props": {
        "children": {
          "type": "code",
          "value": "props.primary_doctor"
        },
        "id": {
          "type": "value",
          "value": "CardAddCoPhysicianUX-label-4"
        },
        "style": {
          "type": "code",
          "value": "{ fontWeight: \"bold\" }"
        }
      },
      "seq": 4,
      "void": false
    },
    {
      "from": null,
      "id": 5,
      "name": "label",
      "parent": 3,
      "props": {
        "children": {
          "type": "value",
          "value": "แพทย์เจ้าของไข้",
          "valueEN": "The attending physician"
        },
        "id": {
          "type": "value",
          "value": "CardAddCoPhysicianUX-label-5",
          "valueEN": ""
        },
        "style": {
          "type": "code",
          "value": "{ color: \"grey\" }"
        }
      },
      "seq": 5,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 8,
      "name": "FormGroup",
      "parent": 1,
      "props": {
        "id": {
          "type": "value",
          "value": "CardAddCoPhysicianUX-FormGroup-8"
        }
      },
      "seq": 12,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 9,
      "name": "FormField",
      "parent": 8,
      "props": {
        "id": {
          "type": "value",
          "value": "CardAddCoPhysicianUX-FormField-9"
        },
        "inline": {
          "type": "value",
          "value": ""
        }
      },
      "seq": 9,
      "void": false
    },
    {
      "from": null,
      "id": 11,
      "name": "label",
      "parent": 9,
      "props": {
        "children": {
          "type": "value",
          "value": "แพทย์ผู้ร่วมรักษา",
          "valueEN": "Associate Physician"
        },
        "id": {
          "type": "value",
          "value": "CardAddCoPhysicianUX-label-11"
        },
        "style": {
          "type": "code",
          "value": "{ color: \"grey\" }"
        }
      },
      "seq": 11,
      "void": false
    },
    {
      "from": null,
      "id": 12,
      "name": "hr",
      "parent": 1,
      "props": {
        "id": {
          "type": "value",
          "value": "CardAddCoPhysicianUX-hr-12"
        }
      },
      "seq": 8,
      "void": true
    },
    {
      "from": "semantic-ui-react",
      "id": 13,
      "name": "FormGroup",
      "parent": 1,
      "props": {
        "id": {
          "type": "value",
          "value": "CardAddCoPhysicianUX-FormGroup-13"
        },
        "style": {
          "type": "code",
          "value": "{ display: \"flex\", alignItems: \"center\", marginBottom: \"30px\" }"
        }
      },
      "seq": 13,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 14,
      "name": "FormField",
      "parent": 13,
      "props": {
        "id": {
          "type": "value",
          "value": "CardAddCoPhysicianUX-FormField-14"
        },
        "width": {
          "type": "code",
          "value": "14"
        }
      },
      "seq": 14,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 15,
      "name": "FormField",
      "parent": 13,
      "props": {
        "id": {
          "type": "value",
          "value": "CardAddCoPhysicianUX-FormField-15"
        },
        "width": {
          "type": "code",
          "value": "2"
        }
      },
      "seq": 15,
      "void": false
    },
    {
      "from": null,
      "id": 16,
      "name": "div",
      "parent": 14,
      "props": {
        "children": {
          "type": "code",
          "value": "props.addDoctorSearchbox"
        },
        "id": {
          "type": "value",
          "value": "CardAddCoPhysicianUX-div-16"
        }
      },
      "seq": 16,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 17,
      "name": "Button",
      "parent": 15,
      "props": {
        "color": {
          "type": "value",
          "value": "green"
        },
        "disabled": {
          "type": "code",
          "value": "!props.addCoPhysicianSequence?.coPhysician?.id"
        },
        "icon": {
          "type": "value",
          "value": "plus"
        },
        "id": {
          "type": "value",
          "value": "CardAddCoPhysicianUX-Button-17"
        },
        "onClick": {
          "type": "code",
          "value": "props.onAddCoPhysician"
        },
        "size": {
          "type": "value",
          "value": "mini"
        }
      },
      "seq": 17,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 18,
      "name": "FormGroup",
      "parent": 1,
      "props": {
        "id": {
          "type": "value",
          "value": "CardAddCoPhysicianUX-FormGroup-18"
        }
      },
      "seq": 18,
      "void": false
    },
    {
      "from": null,
      "id": 19,
      "name": "div",
      "parent": 18,
      "props": {
        "children": {
          "type": "code",
          "value": "props.coPhysicianComponent"
        },
        "id": {
          "type": "value",
          "value": "CardAddCoPhysicianUX-div-19"
        },
        "style": {
          "type": "code",
          "value": "{ width: \"100%\" }"
        }
      },
      "seq": 19,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 20,
      "name": "FormGroup",
      "parent": 1,
      "props": {
        "id": {
          "type": "value",
          "value": "CardAddCoPhysicianUX-FormGroup-20"
        }
      },
      "seq": 20,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 21,
      "name": "FormField",
      "parent": 20,
      "props": {
        "id": {
          "type": "value",
          "value": "CardAddCoPhysicianUX-FormField-21"
        },
        "width": {
          "type": "code",
          "value": "9"
        }
      },
      "seq": 21,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 22,
      "name": "FormField",
      "parent": 20,
      "props": {
        "id": {
          "type": "value",
          "value": "CardAddCoPhysicianUX-FormField-22"
        },
        "width": {
          "type": "code",
          "value": "4"
        }
      },
      "seq": 22,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 23,
      "name": "FormField",
      "parent": 20,
      "props": {
        "id": {
          "type": "value",
          "value": "CardAddCoPhysicianUX-FormField-23"
        },
        "width": {
          "type": "code",
          "value": "3"
        }
      },
      "seq": 23,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 25,
      "name": "Button",
      "parent": 23,
      "props": {
        "children": {
          "type": "value",
          "value": "ปิด",
          "valueEN": "Close"
        },
        "color": {
          "type": "value",
          "value": "red"
        },
        "id": {
          "type": "value",
          "value": "CardAddCoPhysicianUX-Button-25",
          "valueEN": ""
        },
        "onClick": {
          "type": "code",
          "value": "props.onClose"
        }
      },
      "seq": 25,
      "void": false
    },
    {
      "from": null,
      "id": 26,
      "name": "div",
      "parent": 22,
      "props": {
        "children": {
          "type": "code",
          "value": "props.buttonSave"
        },
        "id": {
          "type": "value",
          "value": "CardAddCoPhysicianUX-div-26"
        }
      },
      "seq": 26,
      "void": false
    }
  ],
  "forwardRef": false,
  "height": 80,
  "name": "CardAddCoPhysicianUX",
  "project": "IsHealth",
  "screenPropsDefault": {
    "language": "EN"
  },
  "width": 80
}

*********************************************************************************** */
